"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getEnabledPlaybookAssociations;

var _immutable = require("immutable");

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

function getEnabledPlaybookAssociations(subjectObjectType) {
  switch (subjectObjectType) {
    case _ObjectTypes.default.CONTACT:
    case _ObjectTypes.default.TICKET:
    case _ObjectTypes.default.DEAL:
      return (0, _immutable.Set)([_ObjectTypes.default.COMPANY]);

    default:
      return (0, _immutable.Set)();
  }
}

module.exports = exports.default;